import React, { useEffect, useRef, useState } from 'react';
import { brandPositioning } from '../data/mock';

const BrandPositioning = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section id="about" ref={sectionRef} className="py-24 bg-[#0B0B0B]">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Decorative line */}
        <div 
          className="w-20 h-1 bg-[#2563EB] mb-12 mx-auto"
          style={{
            opacity: isVisible ? 1 : 0,
            transform: isVisible ? 'scaleX(1)' : 'scaleX(0)',
            transition: 'all 0.8s ease-out',
            transformOrigin: 'left'
          }}
        />

        {/* Headline */}
        <h2 
          className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white text-center mb-8 leading-tight"
          style={{
            opacity: isVisible ? 1 : 0,
            transform: isVisible ? 'translateY(0)' : 'translateY(30px)',
            transition: 'all 0.8s ease-out 0.2s'
          }}
        >
          {brandPositioning.headline}
        </h2>

        {/* Content */}
        <p 
          className="text-lg sm:text-xl text-white/70 leading-relaxed text-center"
          style={{
            opacity: isVisible ? 1 : 0,
            transform: isVisible ? 'translateY(0)' : 'translateY(30px)',
            transition: 'all 0.8s ease-out 0.4s'
          }}
        >
          {brandPositioning.content.split('drives action').map((part, index) => (
            index === 0 ? (
              <React.Fragment key={index}>
                {part}
                <span className="text-[#2563EB] font-semibold relative">
                  drives action
                  <span className="absolute bottom-0 left-0 w-full h-0.5 bg-[#2563EB]" />
                </span>
              </React.Fragment>
            ) : (
              part.split('convert views').map((subpart, subindex) => (
                subindex === 0 ? (
                  <React.Fragment key={subindex}>
                    {subpart}
                    <span className="text-[#2563EB] font-semibold relative">
                      convert views
                      <span className="absolute bottom-0 left-0 w-full h-0.5 bg-[#2563EB]" />
                    </span>
                  </React.Fragment>
                ) : (
                  subpart
                )
              ))
            )
          ))}
        </p>
      </div>
    </section>
  );
};

export default BrandPositioning;
